import * as Yup from 'yup';

export const resetPasswordSchema = () => {
    return (
        Yup.object({
            newPassword: Yup.string()
                .trim()
                .required('New password is required')
                .min(8, 'New password must be at least 8 characters long')
                .matches(/[A-Z]/, 'New password must contain at least one uppercase letter')
                .matches(/[a-z]/, 'New password must contain at least one lowercase letter')
                .matches(/\d/, 'New password must contain at least one number')
                .matches(/[^a-zA-Z0-9]/, 'New password must contain at least one special character (e.g., !, @, #, $)'),
            confirmPassword: Yup.string()
                .trim()
                .required('Confirm password is required')
                .oneOf([Yup.ref('newPassword')], 'Passwords must match')
        }));
}
